// removed by extract-text-webpack-plugin
module.exports = {"listNavigation":"_1Ue3s6QIhDYWKehr80nfgg","listItemIcon":"_3zaOMB2WG--HWz_2XGWl4H"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/navigation/list-navigation.scss
// module id = 106
// module chunks = 0